import { render, staticRenderFns } from "./today-charges-card.vue?vue&type=template&id=fa6061e4"
import script from "./today-charges-card.vue?vue&type=script&lang=js"
export * from "./today-charges-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports